module.exports = __webpack_public_path__ + "static/media/products.e34c2a63.jpg";